import { useEffect, useState } from "react";

const Tab = (props) => {
  const { mix, index, activeIndex } = props;

  const [coverPosition, setCoverPosition] = useState("prev");

  useEffect(() => {
    
    if (activeIndex > (index)) {
      setCoverPosition("prev");
    } else if (activeIndex < (index)) {
      setCoverPosition("next");
    } else if (activeIndex === (index)) {
      setCoverPosition("active");
    }
  }, [activeIndex]);


  return (
      <div
        className={`home__tab-wrapper 
            ${coverPosition}`}
      > 
      
      <h1 className={`${mix.title.length >= 20? 'home__small-tab-text':''}`}>
        <div className="home__tab-logo-wrapper" >
          <img src="./assets/RA.svg" className="home__tab-logo"/>
        </div>
        {mix.title}</h1>
        
      </div>
  );
};

export default Tab;
